import Cookies from 'js-cookie'

const TokenKey = 'vue_DATA'
const NickName = 'NickName'
const TrialFlag = 'isTrialUser'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(TokenKey)
  Cookies.remove(TrialFlag)
}

export function getNickName() {
  return Cookies.get(NickName)
}

export function setNickName(token) {
  return Cookies.set(NickName, token)
}

export function setTrialUser(flag) {
  if (flag) Cookies.set(TrialFlag, '1')
  else Cookies.remove(TrialFlag)
}

export function isTrialUserFlag() {
  return Cookies.get(TrialFlag) === '1'
}



// WEBPACK FOOTER //
// ./src/utils/auth.js